import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'age',
  standalone: false,
})
export class AgePipe implements PipeTransform {
  transform(dateOfBirth: string): number {
    return Math.floor(
      (new Date().getTime() - new Date(dateOfBirth).getTime()) / 31557600000,
    );
  }
}
